import gql from 'graphql-tag';

export const SMS_TEST = gql`
  mutation SmsTest($input: SMSTestInput!) {
    smsTest(input: $input)
  }
`;

export default SMS_TEST;